"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderFeedbackModalContent = exports.FEEDBACK_MODAL_CLOSE_BUTTON_TEST_ID = exports.FEEDBACK_MODAL_TEST_ID = void 0;
const View_1 = require("@amzn/atoz-web/View");
const Text_1 = require("@amzn/atoz-web/Text");
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Theme_1 = require("@amzn/atoz-web/Theme");
const react_1 = __importDefault(require("react"));
const ToastIcon_1 = require("../../../../components/Shared/ToastIcon");
exports.FEEDBACK_MODAL_TEST_ID = 'self-classification-feedback-modal';
exports.FEEDBACK_MODAL_CLOSE_BUTTON_TEST_ID = 'self-classification-feedback-modal-close-button';
const renderFeedbackModalContent = ({ feedback }) => {
    const renderModalFunction = ({ close }) => (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: exports.FEEDBACK_MODAL_TEST_ID, titleText: "", buttons: [
            react_1.default.createElement(Button_1.Button, { dataTestId: exports.FEEDBACK_MODAL_CLOSE_BUTTON_TEST_ID, key: "close", variant: Button_1.ButtonVariant.Primary, onClick: () => {
                    window.location.reload();
                } }, "Close")
        ], closeButtonAriaDescribedBy: 'Close' },
        react_1.default.createElement(IconTitleWrapper, null,
            react_1.default.createElement(ToastIcon_1.ToastIcon, { status: feedback.status }),
            react_1.default.createElement(Text_1.H1, { fontSize: "T400", margin: { top: 'S300' }, fontWeight: 500 }, ToastIcon_1.ToastIconStatus[feedback.status].toUpperCase())),
        react_1.default.createElement(Text_1.Text, null, feedback.message)));
    return renderModalFunction;
};
exports.renderFeedbackModalContent = renderFeedbackModalContent;
const IconTitleWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(({ theme }) => `
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: ${theme.selectors.space('S500')}px;
    margin-bottom: ${theme.selectors.space('S200')}px;
  `);
